export default __webpack_public_path__ + "e3877530f380f4aa2a74da1e83bd2003.svg";